import PropTypes from "prop-types";
import React from "react";
import { Grid } from "@material-ui/core";

const GridRow = ({ children }) => (
  <Grid container spacing={3}>
    {children}
  </Grid>
);
GridRow.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GridRow;
